// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TeamSetup {
  flex: 1 1;
  padding: 0 2rem;
  display: flex;
  flex-direction: column;
  align-items: center; }
  .TeamSetup input {
    display: block;
    margin-bottom: 1rem; }
  .TeamSetup .team-title {
    margin-top: 0;
    display: flex;
    align-items: center; }
    .TeamSetup .team-title .starting-team {
      display: inline-block;
      width: 1rem;
      height: 1rem;
      border-radius: 50%;
      margin-left: 0.5rem;
      cursor: pointer;
      opacity: 0.7; }
      .TeamSetup .team-title .starting-team.red {
        background-color: red; }
        .TeamSetup .team-title .starting-team.red.active {
          box-shadow: 0px 0px 7px 0px red; }
      .TeamSetup .team-title .starting-team.blue {
        background-color: #0095ff; }
        .TeamSetup .team-title .starting-team.blue.active {
          box-shadow: 0px 0px 7px 0px #0095ff; }
      .TeamSetup .team-title .starting-team.green {
        background-color: #00b106; }
        .TeamSetup .team-title .starting-team.green.active {
          box-shadow: 0px 0px 7px 0px #00b106; }
      .TeamSetup .team-title .starting-team.active {
        opacity: 1; }
  .TeamSetup .player-wrap {
    position: relative; }
  .TeamSetup form {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    align-items: center; }
  .TeamSetup .players {
    flex: 1 1 auto;
    max-height: 200px;
    margin-bottom: 1rem;
    border-bottom: 2px dashed;
    overflow: scroll; }
  .TeamSetup .remove-player {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0.5rem;
    background: none;
    border: none;
    font-family: inherit;
    cursor: pointer;
    font-size: 1rem; }
`, "",{"version":3,"sources":["webpack://./src/components/TeamSetup.scss","webpack://./src/style/colors.scss"],"names":[],"mappings":"AAcA;EACE,SAAO;EACP,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAA;EALrB;IAQI,cAAc;IACd,mBAAmB,EAAA;EATvB;IAaI,aAAa;IACb,aAAa;IACb,mBAAmB,EAAA;IAfvB;MAkBM,qBAAqB;MACrB,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,mBAAmB;MACnB,eAAe;MACf,YAAY,EAAA;MAlCd;QACE,qBCFqB,EAAA;QDIrB;UACE,+BCLmB,EAAA;MDCvB;QACE,yBCHwB,EAAA;QDKxB;UACE,mCCNsB,EAAA;MDE1B;QACE,yBCAuB,EAAA;QDEvB;UACE,mCCHqB,EAAA;MDS7B;QA4BQ,UAAU,EAAA;EA5BlB;IAkCI,kBAAkB,EAAA;EAlCtB;IAsCI,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,mBAAmB,EAAA;EAzCvB;IA6CI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB,EAAA;EAjDpB;IAqDI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,oBAAoB;IACpB,eAAe;IACf,eAAe,EAAA","sourcesContent":["@import \"./../style/colors\";\n\n@mixin colored-starting-team {\n  @each $name, $hex in $teamColors {\n    &.#{$name} {\n      background-color: $hex;\n\n      &.active {\n        box-shadow: 0px 0px 7px 0px $hex;\n      }\n    }\n  }\n}\n\n.TeamSetup {\n  flex: 1;\n  padding: 0 2rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  input {\n    display: block;\n    margin-bottom: 1rem;\n  }\n\n  .team-title {\n    margin-top: 0;\n    display: flex;\n    align-items: center;\n\n    .starting-team {\n      display: inline-block;\n      width: 1rem;\n      height: 1rem;\n      border-radius: 50%;\n      margin-left: 0.5rem;\n      cursor: pointer;\n      opacity: 0.7;\n      @include colored-starting-team();\n\n      &.active {\n        opacity: 1;\n      }\n    }\n  }\n\n  .player-wrap {\n    position: relative;\n  }\n\n  form {\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 auto;\n    align-items: center;\n  }\n\n  .players {\n    flex: 1 1 auto;\n    max-height: 200px;\n    margin-bottom: 1rem;\n    border-bottom: 2px dashed;\n    overflow: scroll;\n  }\n\n  .remove-player {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    right: 0.5rem;\n    background: none;\n    border: none;\n    font-family: inherit;\n    cursor: pointer;\n    font-size: 1rem;\n  }\n}\n","$background: #f9e5a9;\n$primaryGrey: gainsboro;\n$primaryBlue: rgb(0, 149, 255);\n$primaryRed: rgb(255, 0, 0);\n$primaryYellow: rgb(255, 212, 0);\n$primaryGreen: rgb(0, 177, 6);\n\n$teamColors: (\n  \"red\": $primaryRed,\n  \"blue\": $primaryBlue,\n  \"green\": $primaryGreen,\n);\n\n$cardColors: map-merge(\n  $teamColors,\n  (\n    \"neutral\": $primaryYellow,\n    \"black\": #000,\n  )\n);\n\n$spyCardCellColors: map-merge(\n  $teamColors,\n  (\n    \"black\": #292929,\n  )\n);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
